import React from "react";
import { useTranslation } from "react-i18next";
import type { HelpCenter } from "../../../types";
import { HelpCenterRow } from "./HelpCenterRow";

interface HelpCentersTableProps {
  helpCenters: HelpCenter[];
  onEdit: (id: number) => void;
  onDelete: (id: number) => void;
  formatDate: (dateString: string) => string;
}

export const HelpCentersTable: React.FC<HelpCentersTableProps> = ({
  helpCenters,
  onEdit,
  onDelete,
  formatDate,
}) => {
  const { t } = useTranslation();
  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b">
            <th className="text-left py-1.5 px-2 font-medium text-sm text-muted-foreground">
              {t("helpCenter.table.columnTitle")}
            </th>
            <th className="text-left py-1.5 px-2 font-medium text-sm text-muted-foreground">
              {t("helpCenter.table.columnSlug")}
            </th>
            <th className="text-left py-1.5 px-2 font-medium text-sm text-muted-foreground">
              {t("helpCenter.table.columnUpdated")}
            </th>
            <th className="text-left py-1.5 px-2 font-medium text-sm text-muted-foreground">
              {t("helpCenter.table.columnActions")}
            </th>
          </tr>
        </thead>
        <tbody>
          {helpCenters.map((helpCenter) => (
            <HelpCenterRow
              key={helpCenter.id}
              helpCenter={helpCenter}
              onEdit={onEdit}
              onDelete={onDelete}
              formatDate={formatDate}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

